<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p
            v-if="activeTab == 'info'"
            class="text-[#353535] text-[20px] leading-[20px] font-semibold"
          >
            Viewing {{ customer.displayName }}
          </p>
          <p
            v-if="activeTab == 'account'"
            class="text-[#353535] text-[20px] leading-[20px] font-semibold"
          >
            Viewing {{ customer.displayName }}'s Transactions
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div
          class="bg-white p-1 rounded-[4px] flex items-center gap-[16px] mt-[16px]"
        >
          <button
            :class="[
              'text-[14px] font-normal py-[6px] px-[24px] rounded-[8px] outline-none focus:outline-none',
              {
                'bg-[#2463EB] text-white': activeTab === 'info',
                'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'info',
              },
            ]"
            @click="switchTab('info')"
          >
            Customer info
          </button>
          <button
            v-if="hasPermission('View_Customer_Account')"
            :class="[
              'text-[14px] font-normal py-[6px] px-[24px] rounded-[8px] outline-none focus:outline-none',
              {
                'bg-[#2463EB] text-white': activeTab === 'account',
                'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'account',
              },
            ]"
            @click="switchTab('account')"
          >
            Customer Account
          </button>
        </div>
        <div v-if="activeTab == 'info'">
          <div
            class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]"
          >
            <div>
              <h3
                class="text-[20px] leading-[20px] text-[#2463EB] font-bold mb-[24px]"
              >
                {{ customer.displayName }}
              </h3>
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Email
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ customer.emailAddress }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Delivery Address
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ customer.deliveryAddress }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Phone Number
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ customer.phoneNumber }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Branch
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ customer.branch ? customer.branch.name : "***" }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                State
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ customer.state ? customer.state : "***" }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Local Government Area
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ customer.lga ? customer.lga : "***" }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                ID
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ customer.id }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Created By
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ customer.createdBy }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Created
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ formatDate(customer.created) }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Last Update
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ formatDate(customer.updated) }}</span
              >
            </div>
          </div>
        </div>
        <div v-if="activeTab == 'account'">
          <customerAccount :customerId="customerId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { helper } from "@/helper";
import SystemPermissions from "@/permissions";
import customerAccount from "./customerAccount.vue";
export default {
  props: ["closeModal", "activeTab", "switchTab", "customer", "customerId"],
  components: {
    customerAccount,
  },
  mixins: [SystemPermissions.Mixin],
  name: "customersDetails",
  data() {
    return {
      isBusy: false,
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },

    formatDateWithTime(date) {
      return moment(date).format("ll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
  },
};
</script>

<style></style>
